import { get, set } from '~libs/localstorage';
import { buildSlice, CommonState } from '~libs/reduxUtils';
import { UnallocatedAppointment } from '~weekly-planner/lib/common';

import { typePrefix, unallocatedApi } from '~weekly-planner/actions/appointments/unallocated';

interface State extends CommonState<UnallocatedAppointment> {
  params: { [key: string]: any };
  options: { [key: string]: boolean };
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  params: { limit: 30 },
  options: {
    unallocatedDuration: false,
    unallocatedQualifications: false,
    unallocatedServiceType: true,
    unallocatedSuburb: false,
    ...get('weekly-planner-unallocated-appointment-view-options'),
  },
};

const slice = buildSlice<State, UnallocatedAppointment>(typePrefix, initialState, {
  rtkQueryBridges: [
    {
      endpoint: unallocatedApi.endpoints.getUnallocated,
      mode: 'list',
      apply: (state, payload) => {
        const { rows, total } = payload;
        state.rows = payload.rows as UnallocatedAppointment[];
        state.rows = rows;
        state.count = total;
      },
    },
  ],
  customActions: {
    toggleOption(state, action) {
      const { key, toggle } = action.payload;
      state.options[key] = toggle;
      set('weekly-planner-unallocated-appointment-view-options', state.options);
    },
    updateParams(state, action) {
      state.params = { ...state.params, ...action.payload };
    },
  },
});

export const { clear, updateParams, toggleOption } = slice.actions;

export default slice.reducer;
